/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { Company, CompanyFromJSON, CompanyFromJSONTyped, CompanyToJSON } from './Company'
import { Contact, ContactFromJSON, ContactFromJSONTyped, ContactToJSON } from './Contact'

/**
 *
 * @export
 * @interface GetContactResponseData
 */
export interface GetContactResponseData {
  /**
   *
   * @type {Contact}
   * @memberof GetContactResponseData
   */
  contact?: Contact
  /**
   *
   * @type {Company}
   * @memberof GetContactResponseData
   */
  company?: Company
}

export function GetContactResponseDataFromJSON(json: any): GetContactResponseData {
  return GetContactResponseDataFromJSONTyped(json, false)
}

export function GetContactResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    contact: !exists(json, 'contact') ? undefined : ContactFromJSON(json['contact']),
    company: !exists(json, 'company') ? undefined : CompanyFromJSON(json['company'])
  }
}

export function GetContactResponseDataToJSON(value?: GetContactResponseData | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    contact: ContactToJSON(value.contact),
    company: CompanyToJSON(value.company)
  }
}
